export default "__VITE_ASSET__d7c0e844__"